export class EntitySearchProject {
    public c_project_id: number | null = null;
    public c_project_number: number | null = null;
    public c_project_name: string | null = null;
    public c_client_name: string | null = null;
    public c_project_sponsor_name: string | null = null;
    public c_staff_name: string | null = null;
    // public c_item_name: string | null = null;
    public c_project_cont: string | null = null;
}